const purchase = {
  code: "Supplier Code",
  name: "Supplier Name",
  shortName: "Supplier Short Name",
  country: "Country/Region",
  address: "Address",
  zipCode: "Postal Code",
  email: "Email Address",
  contact: "Contact Person",
  phone: "Phone",
  fax: "Fax",
  mobile: "Mobile",
  account1: "Bank 1",
  bank1: "Account No. 1",
  swiftCode1: "SWIFT/BIC 1",
  account2: "Bank 2",
  bank2: "Account No. 2",
  swiftCode2: "SWIFT/BIC 2",
  creditLevel: "Credit Level",
  creditLine: "Credit Limit",
  depositRate: "Deposit Rate (%)",
  tradeTerm: "Trade Terms",
  payMethod: "Payment Method",
  affiliates: "Affiliated Companies",
  org: "Department",
  taxRate: "Tax Rate (%)",
  taxRate1: "Tax Rate",
  billingDays: "Billing Days",
  principal: "Principal",
  relatedDocuments: "Related Documents (Contract/Business License/Invoicing Info)",
  price: "Price",
  plCode: "Please enter supplier code",
  plName: "Please enter supplier name",
  plShortName: "Please enter supplier short name",
  plAddress: "Please enter supplier address",
  plZipCode: "Please enter supplier postal code",
  plEmail: "Please enter supplier email",
  plContact: "Please enter contact person",
  plPhone: "Please enter supplier phone",
  plFax: "Please enter supplier fax",
  plMobile: "Please enter supplier mobile",
  plBank1: "Please enter account no. 1",
  plAccount1: "Please enter bank 1",
  plSwiftCode1: "Please enter SWIFT/BIC 1",
  plBank2: "Please enter account no. 2",
  plAccount2: "Please enter bank 2",
  plSwiftCode2: "Please enter SWIFT/BIC 2",
  plCreditLine: "Please enter credit limit",
  plDepositRate: "Please enter deposit rate",
  plTradeTerms: "Please select trade terms",
  plPaymentMethod: "Please select payment method",
  plAffiliates: "Please enter affiliated companies",
  plTaxRate: "Please enter tax rate",
  plBillingDays: "Please enter billing days",
  plPrincipal: "Please enter principal",
  wmsApi: "Supplier API",
  plWmsApi: "Please enter supplier API",
  customerList: "Supplier List",
  addCustomer: "Add Supplier",
  documents: "Related Documents",
  codeExisted: 'Supplier code already exists',
  supplierNotExisted: "Supplier does not exist",
  stPrice: 'Unit Price Inc. Tax',
  priceExisted: 'Price already exists for this product',
  product: "Product",
  plPrice: "Please enter unit price inc. tax",
  expiredAt: 'Expiry Date',
  plExpiredAt: 'Please select expiry date',
  priceExpiredAt: 'Validity Period',
  days: 'Lead Time (Days)',
  plDays: 'Please enter lead time',
  mpq: 'Minimum Pack Quantity',
  plMpq: 'Please enter minimum pack quantity',
  remark: 'Remarks',
  plRemark: "Please enter remarks",
  plRemarkMax: 'Content cannot exceed {{ length }} characters',
  priceIndex: 'Product Price {{ index }}',
  priceCount: 'Quantity',
  plPriceCountIndex: 'Tiered price {{ index }} quantity is required',
  plPriceCount: 'Please enter tiered quantity',
  plPriceItemIndex: 'Tiered price {{ index }} unit price inc. tax is required',
  plPriceIndex: 'Please enter the corresponding unit price inc. tax',
  plPriceAdd: 'Add Tiered Price',
  purchaseType: 'Purchase Type',
  plPurchaseType: 'Please select purchase type',
  plSupplier: 'Please select supplier',
  plProduct: 'Please select product and price',
  plProductPrice: 'Please select product and price, enter name to search',
  supplier: 'Supplier Info',
  productCount: 'Product Quantity',
  plProductCount: 'Please enter product quantity',
  scheduledOrderTime: 'Scheduled Order Time',
  plScheduledOrderTime: 'Please select scheduled order time',
  deliveryDeadline: 'Required Delivery Time',
  plDeliveryDeadline: 'Please select required delivery time',
  estimateArrivalAt: 'Estimated Arrival Time',
  plEstimateArrivalAt: 'Please select estimated arrival time',
  deliveredQuantity: 'Cumulative Delivered Quantity',
  plDeliveredQuantity: 'Please select delivered quantity',
  productDesc: 'Product Remarks',
  plProductDesc: 'Please enter product remarks',
  orderDesc: 'Order Remarks',
  plOrderDesc: 'Please enter order remarks',
  productInfo: 'Product Info',
  orderNotExisted: "Purchase order does not exist",
  purchased: 'Ordered',
  notPurchase: 'Not Ordered',
  noPurOrder: 'Pending Purchase',
  orderTime: 'Order Time',
  supplierInfo: 'Supplier Info',
  orderList: 'Purchase Order List',
  addPrice: "Add Product Price",
  bySearchPrice: "Search by inventory code, inventory name, or product model",
  bySearchSupplier: 'Search by supplier code, supplier name, supplier short name, or address',
  orderNumber: 'Order No.',
  purNo: 'Purchase Order No.',
  orderState: 'Order Status',
  type: 'Purchase Type',
  count: 'Purchase Quantity',
  amount: 'Total Price Excl. Tax',
  rateAmount: 'Total Price Inc. Tax',
  priceDetail: "Price Details",
  printedTip: "This order has been printed",
  printSelectTip: "Please select at least one record to print",
  orderNum: "Order No.",
  orderTime1: "Order Date",
  currency: "Currency",
  demandNum: "Demand Order No.",
  quantity: "Quantity",
  priceTax: "Unit Price Inc. Tax",
  totalPrice: "Total Inc. Tax",
  deliveryTime: "Delivery Date",
  total: "Total",
  purchase: "Purchase",
  review: "Review",
  signature: "Supplier Sign-off",
  createTime: "Creation Date",
  reviewTime: "Review Date",
  sigTime: "Sign-off Date",
  notSelect: "Cannot Select",
  selectPurError: "Please select purchase orders with the same supplier",
  selectCurrencyError: "Please select purchase orders with the same currency",
  selectPayMethodError: "Please select purchase orders with the same payment method",
  addOrder: "Add Order",
  searchCode: "Search by inventory code",
  supplierPrint: 'Supplier',
  currencyPoint: 'Currency:',
  purchaseList: 'Purchase Orders',
  pageIndex: 'Page {{ index }} / {{ total }}',
  printReq: 'Generate Purchase Document',
  printRejectedFiltered: "Rejected orders filtered",
  printRejectedFilteredDesc: "{{rejectedCount}} rejected order(s) automatically filtered, remaining {{validCount}} order(s) will be used to generate purchase documents.",
  printRejectedBlocked: "Cannot generate purchase document",
  printRejectedBlockedDesc: "All selected orders are rejected. Please adjust your selection and try again.",
  downloadFile: 'Click to download the generated purchase document',
  successFile: 'Purchase document generated successfully. Starting local print~',
  placeOrder: "Place Order",
  completed: "Completed",
  plPlaceOrder: "Are you sure this order has been placed?",
  plPlaceOrders: "Are you sure these orders have been placed?",
  plOrderOk: "Are you sure this order is completed?",
  plSeSupplier: "Select Supplier",
  plPlacePrice: "Select Order Price",
  search: "Search",
  clearFilters: "Clear Filters",
  materialCode: "Material Code",
  materialName: "Material Name",
  materialModel: "Material Model",
  purCount: "Purchase Quantity",
  supplierTime: "Material Ready Time",
  addPurOrder: "Generate Purchase Order",
  addPurOrderTip: "Auto-generate purchase order",
  roundMethod: "Rounding Method",
  roundNone: "No Rounding",
  roundDown: "Round Down",
  roundUp: "Round Up",
  roundNearest: "Round Nearest",
  addPurSuccessTip: "Purchase orders generated successfully",
  addPurSuccessTipDesc: "Total orders: {{all}}, Purchase orders generated: {{suc}}",
  purConfirm: "Purchase Confirmation",
  conPur: "Confirm Purchase",
  notPur: "Do Not Purchase",
  purCurrency: "Purchase Currency",
  curr: "Currency",
  exchangeRateL: "Exchange Rate",
  purPrice: "Price",
  purPrice_1: "Purchase Price",
  purPrice_2: "Purchase Unit Price",
  all: "Total",
  supplierUserName: 'Supplier Account Name',
  supplierUser: 'Supplier Account',
  supplierReset: 'Reset Password',
  initPwd: 'Initial Password',
  plSupplierUser: 'Please enter supplier account',
  supplierUserAdd: 'Add Supplier Account',
  supplierUserSearch: 'Search by account',
  resetPwd: 'Password will be reset to: {{ newPwd }}',
  resetPwdOk: 'Password reset successful',
  editPwdError: 'Password change failed',
  userList: 'Supplier Account List',
  accounts: 'Supplier Accounts',
  ceil: "Subtotal",
  addNoPurSuccess: "No new purchase orders generated",
  printState: 'Print Status',
  unPrt: 'Not Printed',
  supplierBatchNo: 'Supplier Batch No.',
  batchDeliveryNote: 'Batch Delivery Note',
  batchCompletedProduction: 'Batch Complete',
  batchCompleteSummary: 'Selected {{selected}}',
  batchCompleteNoAvailable: 'No available orders to complete in selection',
  inventoryCode: 'Inventory Code',
  supplierCode: 'Supplier Code',
  supplierName: 'Supplier Name',
  purchaseQuantity: 'Purchase Quantity',
  supplierLot: 'Supplier Batch No.',
  plSupplierLot: 'Please enter supplier batch no.',
  pleaseSelect: 'Please select at least one record',
  pleaseSelectDeliveryTime: 'Please select delivery time',
  pleaseInputDeliveryCount: "Please enter delivery quantity and lot",
  leastOneMoreZero: "At least one delivery quantity must be greater than 0 and lot is required",
  pleaseInputSupplierLot: 'Please enter supplier batch no.',
  batchDeliverySuccess: 'Batch delivery note created successfully',
  plSupplierBatchNo: 'Please enter supplier batch no.',
  maxDeliveryQty: 'Deliverable Quantity',
  noDeliveryData: 'No data to continue generating purchase orders',
  deliveryDate: 'Delivery Time',
  selectDeliveryDate: 'Please select delivery time',
  prt: 'Printed',
  isPrted: 'Is Printed',
  payMethodPoint: "Payment Agreement Name:",
  printCode: 'Material No.',
  printName: 'Product Name',
  printModel: 'Spec/Model',
  spec: 'Specification',
  printUnit: 'Unit',
  printNum: 'Quantity',
  printSPrice: 'Unit Price Inc. Tax',
  printPrce: 'Amount Inc. Tax',
  del: 'Void',
  delTips: 'Void Confirmation',
  delContent: 'Are you sure you want to void this record? Data cannot be recovered after voiding!',
  state: 'Status',
  acceptType: 'Accepted',
  rejectType: 'Rejected',
  pend: 'Pending',
  rejectDetail: 'Rejection Details',
  accept: 'Accept',
  reject: 'Reject',
  rejectDate: 'Rejection Time',
  operationPerson: 'Operator',
  rejectInformate: 'Rejection Info',
  comfi: 'Confirm to accept purchase order?',
  ok: 'Confirm',
  cancel: 'Cancel',
  rejectComfi: 'Confirm to reject purchase order?',
  reOrder: 'Re-select Supplier',
  operate: 'Operation',
  priced: "This product already has a valid quotation!",
  priceManage: 'Quotation Approval',
  selectNumOver: "Maximum 10 selections allowed!",
  onOk: 'Confirm to approve the quotation?',
  onReject: 'Confirm to reject the quotation?',
  payMethodName: 'Payment Agreement',
  helpAcc: 'Assist Acceptance',
  sendTimePrint: 'Delivery Date',
  mobilePrint: 'Contact Phone',
  recver: "Contact Person",
  seq: "No.",
  sendNum: "Delivery Batch No.",
  outLot: "Outbound Batch",
  sendAddress: "Delivery Address",
  printErr: "Print Failed",
  printDeliveryNote: "Print Delivery Note",
  phone1: "Contact Phone",
  orderDetail: "Delivery Note Details",
  sendInfo: "Delivery Information",
  delivery: 'Delivery Note',
  deliveryNumber: 'Delivery Note No.',
  deliveryStatus: 'Completion Status',
  updatePurchaseOrderStatus: 'Update Purchase Order Status',
  purchaseOrderStatus: 'Purchase Order Status',
  deliverable: 'Deliverable',
  notDeliverable: 'Not Deliverable',
  inState: 'Arrival Status',
  unArrived: 'Not Arrived',
  partialIn: 'Partially Arrived',
  allIn: 'Fully Arrived',
  pendingProduction: 'Pending Production',
  inProduction: 'In Production',
  finishedProduction: 'Finished',
  completedProduction: 'Completed',
  confirmCompletedProduction: 'Confirm to complete this order?',
  confirmBatchCompletedProduction: 'Confirm to batch complete these orders?',
  markAsFinished: 'Mark as Finished',
  confirmFinish: 'Confirm to finish this item?',
  complete: 'Complete',
  startProduction: 'Start Production',
  markAsFinishedProduction: 'Mark as Finished',
  confirmFinishProduction: 'Confirm to mark this item as finished?',
  confirmMarkAsInProduction: 'Confirm to mark as In Production?',
  confirmMarkAsFinished: 'Confirm to mark as Finished?',
  markAsInProduction: 'Mark as In Production',
  selectStatus: 'Select Status',
  confirmMarkAsStatus: 'Confirm to mark as <strong>{{status}}</strong>?',
  deliveryDatePlaceholder: 'Latest Delivery Date',
  notInStock: 'Not In Stock',
  inStock: 'In Stock',
  deliveryOrders: 'Delivery Orders Generated',
  goodName: 'Material Name',
  goodCode: 'Inventory Code',
  goodModel: 'Model',
  preInventory: 'Pre-inbound Order',
  saveCodes: 'Save Barcodes',
  clearCodes: 'Clear Barcodes',
  outOrder: 'In/Out Order Generated',
  isOut: 'Outbound',
  notOut: 'Not Outbound',
  hasPurOrder: 'Purchase Order Generated',
  outOrderNumber: 'Outbound Order No.',
  goodsExpiredAt: 'Material Expiry Date',
  plGoodsExpiredAt: 'Please enter material expiry date',
  year: 'Year',
  helpAccSuc: 'Assisted the supplier in accepting the quotation.',
  helpRejSuc: 'Assisted the supplier in rejecting the quotation.',
  noReq: 'Cannot reselect supplier!',
  noReqDesc: 'This purchase order has no enquiry, so supplier cannot be reselected',
  equotationRequest: 'Enquiry Status',
  receivingUnit: 'Receiving Unit',
  receivingAddress: 'Delivery Address',
  deliveryProgress: 'Delivery Progress',
  zfed: "Voided",
  mainCurPrice: "Base Currency Amount",
  billingDay: "Billing Days:",
  sendAdd: "Delivery Address:",
  unRatePrice: "Unit Price Excl. Tax",
  nilPur: "Not Generated",
  purState: "Purchase Order Status",
  sendAds: "Delivery Address",
  sendAdsPl: "Please select delivery address",
  accer: "Receiver",
  rePrt: "Reprint",
  rePrtCon: "Confirm to reprint?",
  plRePrt: "Please reprint",
  onlyOneReq: "Only orders from the same demand order can be selected",
  multyDown: "Batch Download",
  downErr: "Download Failed",
  leastOne: "Select at least one record",
  inReturn: "Returned to Stock",
  stocked: "Is it stocked?",
  selectDateError: "Only orders with the same delivery time can be selected",
  spareRate: "Spare Rate (%)",
  spareRate_1: "Spare Rate",
  spareRatePl: "Please enter spare rate",
  spareCount: "Spare Quantity",
  spareCountPl: "Please enter spare quantity",
  cancelReturn: "Cancel Return",
  reqPur: "Demand Order/Purchase Order",
  pdaPrint: "Purchase Order PDA Print",
  qcNum: "Sampling Quantity",
  qcNo: "Defective Quantity",
  qcOk: "Inspection Result",
  qc: "Approved By",
  pg: "Quality Control",
  cg: "Warehouse Keeper",
  outPrint: "Outbound Order Print",
  checkoutOrder: "Inspection Order",
  normalTemplate: "Normal Template",
  warehouseTemplate: "Warehouse Template",
  brand: "Brand",
  plBrand: "Please enter brand",
  dictCurrency: "Currency",
  printSetting: "Print Settings",
  otherInfo: "Material Label",
  originalBrand: "Original Brand",
  originalCode: "Original Code",
  mpn: "MPN",
  plMpn: "Please enter MPN",
  manufactureDate: "Manufacturing Date",
  msdLevel: "MSD Level",
  dcc: "D/C",
  plShelfLife: "Please enter shelf life",
  originPlace: "Origin",
  netWeight: "Net Weight",
  grossWeight: "Gross Weight",
  plOriginalBrand: "Please enter original brand",
  plOriginalCode: "Please enter original code",
  plManufactureDate: "Please enter manufacturing date",
  plMsdLevel: "Please enter MSD level",
  plOriginPlace: "Please enter origin",
  plNetWeight: "Please enter net weight",
  plGrossWeight: "Please enter gross weight",
  importSupplierPrice: 'Import Supplier Price',
  downloadPriceTemplate: 'Download Price Template',
  importSuccess: 'Import Successful',
  importSuccessDesc: 'Successfully imported price data for {{count}} materials',
  importCompleted: 'Import Completed',
  importPartialDesc: 'Success: {{success}}, Failed: {{failed}} ({{failedList}})',
  fileParseError: 'File parsing failed, please check file format',
  templateWarningTitle: 'Notice',
  templateWarningIntro: 'Please follow the price template guidelines:',
  templateWarning1: '1. Multiple materials can be filled in at once. Please ensure material codes are correct;',
  templateWarning2: '2. Each material can have multiple rows. The first row is the base price (quantity cannot be filled). Second and subsequent rows are tiered prices (inventory code, unit price inc. tax, and quantity required);',
  templateWarning3: '3. Ensure the settlement currency exists in the system (case-insensitive);',
  templateWarning4: '4. Ensure effective date and expiry date fields are 8-digit numbers, e.g., 20260309 (March 9, 2026);',
  templateWarning5: '5. Incorrect data may cause parsing failure or import errors;',
  templateWarning6: '6. Supplier code column is required;',
  iHaveKnown: 'I have acknowledged',
  confirmOrder: 'Confirm order?',
  confirmOrderTip: 'Confirm to place order?',
  incompleteRecipientInfo: 'Receiving unit, delivery address, contact person, phone number, etc., are incomplete.',
  pleaseCompleteRecipientInfo: 'Please complete recipient info',
  recipientInfoDetails: 'Receiving unit, delivery address, contact person, phone number',
  syncToSupplier: 'Sync Supplier Status',
  priceTemplateFileName: 'Supplier Price Template',
  excelHeaderInventoryCode: 'Inventory Code',
  excelHeaderUnitPriceIncludingTax: 'Unit Price Inc. Tax',
  excelHeaderMaterialValidityPeriod: 'Material Validity Period (Years)',
  excelHeaderSupplyCycle: 'Lead Time (Days)',
  excelHeaderMinimumPackage: 'Min Pack Qty',
  excelHeaderQuantity: 'Quantity',
  excelHeaderSettlementCurrency: 'Settlement Currency',
  excelHeaderBrand: 'Brand',
  excelHeaderMpn: 'MPN',
  excelHeaderShelfLife: 'D/C',
  supplierPrice: 'Supplier Price',
  supplierHisPrice: 'Supplier Historical Price',
  hisPriceExport: 'Historical Price Export',
  allPriceHis: 'Export All Historical Prices',
  generated: "Generated",
  importInbound: "Import to Generate Delivery Note",
  inboundTemplate: "Delivery Note Import Template",
  sendTime: "Delivery Date",
  inboundTemplateTip1: "1. Delivery date must be an 8-digit number, e.g., 20260311 (March 11, 2026)",
  inboundTemplateTip2: "2. Fill in the delivery quantity for this purchase order",
  inboundTemplateTip3: "3. Records with the same purchase order number and delivery time will be merged, quantities summed",
  inboundTemplateTip4: "4. Incorrect data may cause parsing or import failure!",
  inboundTemplateTip5: "5. The lot column is optional; if left blank, the system will automatically generate a batch",
  noData: "No data parsed",
  matchErr: "Purchase order data matching failed, please retry!",
  importDone: "Import completed",
  succNum: "Success Count",
  importErrTip: "The following purchase orders need data verification",
  maxQuantityErr: "Total delivery quantity for the following purchase orders exceeds deliverable quantity",
  excelCount: "Total Delivery Quantity",
  purNoErr: "Row {{index}}: Purchase order number validation error",
  countErr: "Row {{index}}: Delivery quantity error",
  preTimeErr: "Row {{index}}: Delivery time error",
  importErr: "Data matching failed, no data imported",
  notPurNo: 'The following purchase orders do not exist',
  numAdds: 'Total Quantity',
  rateNumAdds: 'Total Amount Inc. Tax',
  ratePceAdds: 'Total Unit Price Inc. Tax',
  toReturn: "Pending Return",
  returnQty: "Return Quantity",
  actualArrivalQty: "Actual Arrival Quantity",
  actualArrivalTime: "Actual Arrival Time",
  undeliveredQty: "Undelivered Quantity",
  orderNums: "Delivery Note Quantity",
  importSuppOrders: "Import to Generate Supplier Delivery Note",
  allSendQty: "Total Delivery Quantity",
  sentQty: "Delivered Quantity",
  sendQty: "Current Delivery Quantity",
  remainQTy: "Remaining Delivery Quantity",
  noSendInfo: "No delivery info",
  fileLoss: "Import source file missing!",
  import: "Import Template Data",
  matchPur: "Match Purchase Order",
  done: "Complete",
  thdCode: "MES Customer Code",
  plThdCode: "Please enter MES customer code",
  batchSubmit: 'Batch Quotation',
  batchSubmitSucc: 'Batch quotation successful',
  batchSubmitErr: 'Batch quotation failed',
  needPriceTip: 'The following data require manual price entry',
  batchSubmitTip: 'Confirm to submit quotations for selected enquiries?',
  actualInboundTime: "Actual Inbound Time",
  supplierCodeNeed: "Supplier code does not exist at row {{index}}, parsing failed",
  addRule: "Add purchase order trade terms?",
  effectiveAt: "Effective Date",
  expiredAtEcl: "Expiry Date",
  effectiveAtPl: "Please select effective date",
  expiredAtEclPl: "Please select expiry date",
  purOrderPl: "Please select purchase order",
  notApi: "This supplier does not have an API configured, cannot transfer order!",
  swapData: "Transfer Data",
  swapDone: "Transfer Complete",
  notSuppPros: "These products do not exist in the supplier's system. Please add them in the supplier's system.",
  notSaleProPrice: "The customer price for this end customer does not exist in the supplier's system. Please add these customer prices.",
  purchaseTransferSuccess: "Purchase order transfer to sales order completed",
  noRejected: "This purchase order has been rejected and cannot be transferred!",
  swapErr: "Transfer failed",
  startSwap: "Start Transfer",
  priceComputedTip: "Product quantity or tax rate has changed. Price needs to be recalculated.",
  selectPurErrorTip: "Please select items with the same supplier, same settlement currency, and same payment method",
  notResolved: "This purchase order is not in accepted status and cannot be selected",
  printedTipErr: "The following items have been printed and cannot be printed again",
  downloadTip: "PDF generated. Download now?",
  pdfIng: "Generating PDF",
  addPurchaseOrder: "Add Purchase Order",
  addItem: "Add Order Item",
  item: "Order Item",
  items: "Order Items",
  plCurrency: "Please select currency",
  plPayMethod: "Please select payment method",
  ladderPrice: "Ladder Price",
  ladderPriceCount: "Quantity",
  productType: "Product Type",
  brandName: "Brand Name",
  brandModel: "Brand Model",
};

export default purchase;
